import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from 'app/scripts/components/common/inputs/select-input';

var TimeKeys = {
  FIVE_MINUTES: { value: 5, text: '5 minutes' },
  FIFTEEN_MINUTES: { value: 15, text: '15 minutes' },
  ONE_HOUR: { value: 60, text: '1 hour' },
  SIX_HOURS: { value: 360, text: '6 hours' },
  TWELVE_HOURS: { value: 720, text: '12 hours' }
};

function getDuration(value) {
  var duration = null;
  switch (value) {
    case 60:
      duration = TimeKeys.ONE_HOUR;
      break;
    case 360:
      duration = TimeKeys.SIX_HOURS;
      break;
    case 720:
      duration = TimeKeys.TWELVE_HOURS;
      break;
    case 5:
      duration = TimeKeys.FIVE_MINUTES;
      break;
    case 15:
    default:
      duration = TimeKeys.FIFTEEN_MINUTES;
      break;
  }
  return duration;
}

class BroadcastDuration extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      duration: getDuration(props.value)
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var oldDuration = this.props.value;
    var newDuration = nextProps.value;
    if (oldDuration !== newDuration) {
      this.setState({ duration: getDuration(newDuration) });
    }
  }
  handleDurationChange(duration) {
    this.setState({ duration });
  }
  getValue() {
    return this.state.duration.value;
  }
  render() {
    var value = this.state.duration;
    var { disabled } = this.props;
    return (
      <div className="field">
        <SelectInput
          description="Duration of Broadcast"
          onChange={this.handleDurationChange.bind(this)}
          options={[
            TimeKeys.FIVE_MINUTES,
            TimeKeys.FIFTEEN_MINUTES,
            TimeKeys.ONE_HOUR,
            TimeKeys.SIX_HOURS,
            TimeKeys.TWELVE_HOURS
          ]}
          value={value}
          disabled={disabled}
        />
      </div>
    );
  }
}

BroadcastDuration.propTypes = {
  validate: PropTypes.bool,
  disabled: PropTypes.bool,
  // value: PropTypes.number
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

BroadcastDuration.displayName = 'BroadcastDuration';

export default BroadcastDuration;
